import { createDateOnly } from './FormatHelpers'

/**
 * Generates an array of dates based on start date, unit type, and number of occurrences
 * For weekly bookings, selectedWeekDays specifies which days of the week to book
 */
export const generateDateRange = (
  startDate: Date,
  unit: 'Once off' | 'Same days every week',
  num: number,
  selectedWeekDays?: number[]
): Date[] => {
  const dateList: Date[] = []

  if (unit === 'Once off') {
    // Consecutive days
    for (let index = 0; index < num; index++) {
      const forDate = createDateOnly(new Date(startDate))
      forDate.setDate(forDate.getDate() + index)
      dateList.push(forDate)
    }
  } else {
    // Weekly recurring - generate dates for selected days over 13 weeks
    if (!selectedWeekDays || selectedWeekDays.length === 0) {
      return dateList
    }

    const weeksToBook = 13 // 3 months
    const start = createDateOnly(new Date(startDate))

    for (let week = 0; week < weeksToBook; week++) {
      for (const dayOfWeek of selectedWeekDays) {
        const bookingDate = new Date(start)
        const startDayOfWeek = start.getDay()
        let daysToAdd = dayOfWeek - startDayOfWeek
        if (daysToAdd < 0) daysToAdd += 7
        daysToAdd += week * 7

        bookingDate.setDate(start.getDate() + daysToAdd)
        dateList.push(bookingDate)
      }
    }
  }

  return dateList
}

/**
 * Calculates the minimum date from an array of dates
 * Returns the current date if the array is empty
 */
export const getMinimumDate = (dates: Date[]): Date => {
  if (dates.length === 0) {
    return new Date()
  }
  return dates.reduce((a, b) => (a < b ? a : b))
}

/**
 * Calculates the difference in days for booking queries
 */
export const calculateBookingDayRange = (
  unit: 'Once off' | 'Same days every week',
  number: number
): number => {
  return unit === 'Once off' ? number : 10
}
